export default __webpack_public_path__ + "static/media/whatsapp_banner_headline_desktop_new.1e160c51.gif";